export const xeroTenantsConstants = {
  XERO_TENANTS_LIST_LOADING: 'XERO_TENANTS_LIST_LOADING',
  XERO_TENANTS_LIST_SUCCESS: 'XERO_TENANTS_LIST_SUCCESS',
  XERO_TENANTS_LIST_FAILURE: 'XERO_TENANTS_LIST_FAILURE',

  XERO_TENANTS_DELETE_LOADING: 'XERO_TENANTS_DELETE_LOADING',
  XERO_TENANTS_DELETE_SUCCESS: 'XERO_TENANTS_DELETE_SUCCESS',
  XERO_TENANTS_DELETE_FAILURE: 'XERO_TENANTS_DELETE_FAILURE'
};
